const svgMap = (gsap) => {
  let mapSvg = document.querySelector(".new-homepage-map");
  if (!mapSvg) return;

  let tabSelect = document.querySelector(".block-buttons").querySelectorAll(".secondary-button");

  const phaseMap = {
    "tab-1": mapSvg.querySelector("#Established"),
    "tab-2": mapSvg.querySelector("#In_Development"),
    "tab-3": mapSvg.querySelector("#Future_Vision"),
  };

  let activeGroup = null;

  const getShapes = (group) => {
    if (!group) return [];
    return group.querySelectorAll("path, polygon, polyline, rect, line, circle, ellipse");
  };

  const getAccentColor = () =>
    window.getComputedStyle(document.documentElement).getPropertyValue("--color-accent");

  const getContrastColor = () =>
    window.getComputedStyle(document.documentElement).getPropertyValue("--color-contrast-text") || "#fff";

  const getEmptyColor = () => "#b6aeae";

  tabSelect.forEach((tab) => {
    tab.addEventListener("click", function () {
      const targetGroup = phaseMap[tab.getAttribute("id")];

      // Reset all phases
      Object.values(phaseMap).forEach((group) => {
        if (!group) return;
        group.classList.remove("active");
        gsap.to(getShapes(group), {
          fill: getEmptyColor,
          stroke: "#000",
          duration: 1,
          ease: "back.out(1)",
        });
      });

      // Highlight selected phase
      if (targetGroup) {
        activeGroup = targetGroup;
        targetGroup.classList.add("active");
        gsap.to(getShapes(targetGroup), {
          fill: getAccentColor,
          stroke: getContrastColor(),
          duration: 1,
          ease: "back.out(1)",
        });
      } else {
        activeGroup = null;
      }
    });
  });

  class TabsAutomatic {
    constructor(groupNode) {
      this.tablistNode = groupNode;

      this.tabs = [];

      this.firstTab = null;
      this.lastTab = null;

      this.tabs = Array.from(this.tablistNode.querySelectorAll("[role=tab]"));

      for (var i = 0; i < this.tabs.length; i += 1) {
        var tab = this.tabs[i];

        tab.tabIndex = -1;
        tab.setAttribute("aria-selected", "false");

        tab.addEventListener("keydown", this.onKeydown.bind(this));
        tab.addEventListener("click", this.onClick.bind(this));

        if (!this.firstTab) {
          this.firstTab = tab;
        }
        this.lastTab = tab;
      }

      this.setSelectedTab(this.firstTab, false);
    }

    setSelectedTab(currentTab, setFocus) {
      if (typeof setFocus !== "boolean") {
        setFocus = true;
      }
      for (var i = 0; i < this.tabs.length; i += 1) {
        var tab = this.tabs[i];
        if (currentTab === tab) {
          tab.setAttribute("aria-selected", "true");
          tab.removeAttribute("tabindex");
          if (setFocus) {
            tab.focus();
          }
        } else {
          tab.setAttribute("aria-selected", "false");
          tab.tabIndex = -1;
        }
      }
    }

    setSelectedToPreviousTab(currentTab) {
      var index;
      if (currentTab === this.firstTab) {
        this.setSelectedTab(this.lastTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(this.tabs[index - 1]);
      }
    }

    setSelectedToNextTab(currentTab) {
      var index;
      if (currentTab === this.lastTab) {
        this.setSelectedTab(this.firstTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(this.tabs[index + 1]);
      }
    }

    onKeydown(event) {
      var tgt = event.currentTarget,
        flag = false;

      switch (event.key) {
        case "ArrowLeft":
          this.setSelectedToPreviousTab(tgt);
          flag = true;
          break;

        case "ArrowRight":
          this.setSelectedToNextTab(tgt);
          flag = true;
          break;

        case "Home":
          this.setSelectedTab(this.firstTab);
          flag = true;
          break;

        case "End":
          this.setSelectedTab(this.lastTab);
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    }

    onClick(event) {
      this.setSelectedTab(event.currentTarget);
    }
  }

  window.addEventListener("load", function () {
    var tablists = document.querySelectorAll("[role=tablist].automatic");
    for (var i = 0; i < tablists.length; i++) {
      new TabsAutomatic(tablists[i]);
    }

    // Paint initial active phase (tab-1 / Established)
    const firstGroup = phaseMap["tab-1"];
    if (firstGroup) {
      activeGroup = firstGroup;
      firstGroup.classList.add("active");
      gsap.set(getShapes(firstGroup), { fill: getAccentColor(), stroke: getContrastColor() });
    }
  });
};

export { svgMap };
